const videos = async function () {
    function playPauseVideo() {
        let videos = document.querySelectorAll("video");
        videos.forEach((video) => {
            // We can only control playback without insteraction if video is mute
            video.muted = true;
            // Play is a promise so we need to check we have it
            let playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.then((_) => {
                    let observer = new IntersectionObserver(
                        (entries) => {
                            entries.forEach((entry) => {
                                if (
                                    entry.intersectionRatio !== 1 &&
                                    !video.paused
                                ) {
                                    // video.pause();
                                } else if (video.paused) {
                                    video.play();
                                    video.muted = true;
                                }
                            });
                        },
                        { threshold: 0.2 }
                    );
                    observer.observe(video);
                });
            }
        });
    }
    
    window.addEventListener("resize", playPauseVideo);
    
    // And you would kick this off where appropriate with:
    playPauseVideo();

    // Lazyload
    const videos = document.querySelectorAll("video.lazy-video");

    function elementInViewport2(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;
      
        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

      
        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }

    if ( videos ) {
        window.onscroll = function() { 
            videos.forEach(video => {
                if ( !video.src && elementInViewport2(video) ) {
                    if ( window.innerWidth >= 768 && !video.dataset.mobileSrc ) {
                        video.src = video.dataset.src;
                    } else {
                        video.src = video.dataset.mobileSrc;
                    } 
                }
            });
        };
    }
}

export const init = videos;